import {CreacionUsuario} from '../interfaces/creacionUsuario.interface'

export const creacionUsuarioInitialState: CreacionUsuario = {
  formUser: {
    username: '',
    passwd: '',
    passwd2: '',
    birth_date: '',
    first_name: '',
    second_name: '',
    third_name: '',
    last_name: '',
    last_name2: '',
    last_name_married: '',
    nit: '',
    id_number: '',
    codigo_empresa: '',
    email: '',
    phone_number: '',
    location: '',
    role_access_user: '',
    description: '',
    username2: '',
    tipoDocumento: '',
    nombreTipoDocumento: '',
  },
  formError: {
    username: '',
    passwd: '',
    passwd2: '',
    birth_date: '',
    first_name: '',
    second_name: '',
    third_name: '',
    last_name: '',
    last_name2: '',
    last_name_married: '',
    nit: '',
    id_number: '',
    codigo_empresa: '',
    email: '',
    phone_number: '',
    location: '',
    role_access_user: '',
    description: '',
    tipoDocumento: '',
  },
  codeVerify: {
    code: '',
    error: '',
  },
  paginaActual: 0,
}
